import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import CashbackOfferModal from './CashbackOfferModal';

const RewardPointsToast = () => {

    const [isModalOffer, setIsModalOffer] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    return (
        <>
            {!isVisible && (
                <div className='RewardPointsToast mb-2'>
                    <div className='card-header'>
                        <div className='d-md-flex align-items-center justify-content-between position-relative'>
                            <div className='d-flex align-items-center'>
                                <p onClick={() => setIsModalOffer(true)} style={{ cursor: 'pointer' }}>
                                    100% cashback as Reward Points
                                </p>
                            </div>
                            <div className='d-none align-items-center' onClick={() => setIsModalOffer(true)} style={{ cursor: 'pointer' }}>
                                <p className='d-flex align-items-center'>
                                    ₹1 =
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" className='mx-1' fill='var(--primary-color) !important'>
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                                        </g>
                                    </svg>
                                    1 Point
                                </p>
                            </div>
                        </div>
                        <a className='ms-2 ToastHide' href='#' aria-label="Close notification" onClick={toggleVisibility}>
                            <FaTimes />
                        </a>
                    </div>
                </div>
            )}

            <CashbackOfferModal
                isModalOffer={isModalOffer}
                setIsModalOffer={setIsModalOffer}
            />

        </>
    );
};

export default RewardPointsToast;
